import {
  createTypesenseClient,
  getBeerNameHighlightFromTypesenseHit,
  getCollectionNames,
  getTypesenseSearchConfigError,
  TYPESENSE_SEARCH_CONFIG_ERROR,
} from '../utils/typesense';

/**
 * Resolve Typesense client + beer collection, or an error string.
 */
export function resolveBeerSearchClient() {
  const configError = getTypesenseSearchConfigError();
  if (configError) {
    return { error: configError, client: null, collectionName: null };
  }

  const mode = (import.meta.env.MODE || 'development').toLowerCase();
  const env = ['development', 'staging', 'production'].includes(mode)
    ? mode
    : 'development';
  const { beer: collectionName } = getCollectionNames(env);
  if (!collectionName) {
    return {
      error: TYPESENSE_SEARCH_CONFIG_ERROR,
      client: null,
      collectionName: null,
    };
  }

  const client = createTypesenseClient();
  if (!client) {
    return {
      error: TYPESENSE_SEARCH_CONFIG_ERROR,
      client: null,
      collectionName: null,
    };
  }

  return { error: null, client, collectionName };
}

/**
 * Build Typesense filter_by for catalog style document ids.
 */
export function buildStyleIdFilter(styleIds) {
  if (!Array.isArray(styleIds) || styleIds.length === 0) {
    return null;
  }
  const escapedIds = styleIds
    .map((styleId) => String(styleId).replace(/`/g, ''))
    .filter((styleId) => styleId.length > 0);
  if (escapedIds.length === 0) {
    return null;
  }
  return `style:=[${escapedIds.map((styleId) => `\`${styleId}\``).join(',')}]`;
}

/**
 * Map Typesense hits to beer list rows.
 */
export function mapBeerSearchHits(hits) {
  return (hits ?? []).map((hit) => {
    const doc = hit.document ?? hit;
    const highlight = getBeerNameHighlightFromTypesenseHit(hit);
    return {
      id: doc.id ?? hit.id,
      ...doc,
      highlight,
    };
  });
}
